import type { BaseKeyFunction } from "../../../lib";

export type KeyPagesProps = { page: string };

export const keyPages: BaseKeyFunction<KeyPagesProps> = ({ page }) => [
  "pages",
  page,
];
